import { array, number, object, string } from 'yup';

const rangeSchema = object().shape({
  rangeFrom: number().required('Range From is required').typeError('Range From must be a number'),
  rangeTo: number()
    .required('Range To is required')
    .typeError('Range To must be a number')
    .test('is-greater', 'Range To must be greater than Range From', function isGreater(value) {
      const { rangeFrom } = this.parent;
      return value >= rangeFrom;
    }),
  answer: string().required('Answer is required'),
});

const questionSchema = object().shape({
  type: string().trim().required('Type is required').max(30, 'Max 30 characters'),
  question: string().required('Question is required'),
  questionAnswers: array().of(rangeSchema).min(2, 'At least two ranges are required').required('Ranges are required'),
});

const schema = object().shape({
  questions: array().of(questionSchema).min(1, 'At least one question is required').required('Questions are required'),
});

export default schema;
